__turbopack_context__.v({
  "placeholder": "KfZMMW_placeholder",
});
